export const locale = {
    lang: 'nl',
    data: {
      'WIZARD': {
        'TESTTITULO': 'WIZARD TITLE ',
        'CARGANDO': 'Laden van verworven producten',
        'CARGANDO_PULSOS': 'Laden pulsen in proces',
        'SINPRODS': 'U heeft dit product niet aangeschaft',
        'EVALUADOR':{
          'TITUTLO':'Evaluator'
        },
        'LANDING': {
          'PRODUCTO': {
            'CERTIFICAR':{
              'TITULO': 'Welkom bij CULTURAL GO!',
              'CURRENT': 'Dit is uw huidige enquêteproces',
              'FINISHED': 'Dit is een afgerond onderzoeksproces',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Dit is uw huidige enquêteproces',
                'FINISHED5': 'Verwerk resultaten'
              }
            },
            'Amco':{
              'TITULO': 'WELKOM BIJ AMCO',
              'CURRENT': 'Dit is het huidige amco-proces',
              'FINISHED': 'Dit is een voltooid amco-proces',
              'RESULTS': {
                'CURRENT': 'Amco process not finished',
                'FINISHED': 'Dit is het huidige resultaatproces',
                'FINISHED5': 'Verwerk resultaten'
              }
            },
            'Trabajo_digno':{
              'TITULO': 'WELKOM BIJ WAARDIG WERK',
              'CURRENT': 'Dit is het huidige waardig-werkproces',
              'FINISHED': 'Dit is een voltooid fatsoenlijk werkproces',
              'RESULTS': {
                'CURRENT': 'Decent work process not finished.',
                'FINISHED': 'Dit is het huidige resultaatproces',
                'FINISHED5': 'Verwerk resultaten'
              }
            },
            'Primer_empleo':{
              'TITULO': 'WELKOM BIJ EERSTE BAAN',
              'CURRENT': 'Dit is het huidige eerste tewerkstellingsproces',
              'FINISHED': 'Dit is een afgerond eerste baanproces',
              'RESULTS': {
                'CURRENT': 'First employment process not completed',
                'FINISHED': 'Dit is het huidige resultaatproces',
                'FINISHED5': 'Verwerk resultaten',
              }
            },
            'CERTIFICAR_ESPAIN':{
              'CURRENT': 'Dit is uw huidige enquêteproces',
              'FINISHED': 'Dit is een afgerond onderzoeksproces',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Dit is uw huidige enquêteproces',
                'FINISHED5': 'Verwerk resultaten'
              }
            },
            'CERTIFICAR_C1':{
              'TITULO': 'Welkom bij CULTURAL GO!',
              'CURRENT': 'Dit is uw huidige enquêteproces',
              'FINISHED': 'Dit is een afgerond onderzoeksproces',

              //ESPAÑA
              'TITULO_ESPAIN': 'Welkom bij CULTURAL GO!',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Dit is uw huidige enquêteproces',
                'FINISHED5': 'Verwerk resultaten'
              }
            },
            'CERTIFICAR_C2':{
              'TITULO': 'Welkom bij CULTURAL GO!',
              'CURRENT': 'Dit is uw huidige enquêteproces',
              'FINISHED': 'Dit is een afgerond onderzoeksproces',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Dit is uw huidige enquêteproces'
              }
            },
            'CERTIFICAR_C3':{
              'TITULO': 'Welkom bij CULTURAL GO!',
              'CURRENT': 'Dit is uw huidige enquêteproces',
              'FINISHED': 'Dit is een afgerond onderzoeksproces',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Dit is uw huidige enquêteproces',
                'FINISHED5': 'Verwerk resultaten'
              }
            },
            'CERTIFICAR_C4':{
              'TITULO': 'WELKOM OM ZILVER TE CERTIFICEREN',
              'CURRENT': 'Dit is uw huidige enquêteproces',
              'FINISHED': 'Dit is een afgerond onderzoeksproces',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'Dit is uw huidige enquêteproces',
                'FINISHED5': 'Verwerk resultaten'
              }
            },
            'MEDIR':{
              'TITULO': 'WELKOM BIJ METING',
              'CURRENT': 'Dit is uw huidige meetproces',
              'FINISHED': 'Dit is een voltooid meetproces',
              'RESULTS': {
                'CURRENT': 'Het meetproces is niet voltooid',
                // 'FINISHED': 'Finished measurement process'
                'FINISHED': 'Dit is uw huidige meetproces',
                'FINISHED5': 'Verwerk resultaten'

              }
            },
            'MEDIR_M1':{
              'TITULO': 'WELKOM BIJ METING VERBETERD',
              'CURRENT': 'Dit is uw huidige meetproces',
              'FINISHED': 'Dit is een voltooid meetproces',
              'RESULTS': {
                'CURRENT': 'Het meetproces is niet voltooid',
                'FINISHED': 'Afgerond meetproces'
              }
            },
            'MEDIR_M2':{
              'TITULO': 'WELKOM BIJ MEASUREMENT + MST',
              'CURRENT': 'Dit is uw huidige meetproces',
              'FINISHED': 'Dit is een voltooid meetproces',
              'RESULTS': {
                'CURRENT': 'Het meetproces is niet voltooid',
                'FINISHED': 'Afgerond meetproces'
              }
            },
            'MEDIR_M3':{
              'TITULO': 'WELKOM BIJ METING OP GEBIEDEN',
              'CURRENT': 'Dit is uw huidige meetproces',
              'FINISHED': 'Dit is een voltooid meetproces',
              'RESULTS': {
                'CURRENT': 'Het meetproces is niet voltooid',
                'FINISHED': 'Afgerond meetproces'
              }
            },
            'MEDIR_M4':{
              'TITULO': 'WELKOM BIJ METING DOOR LEIDERS',
              'CURRENT': 'Dit is uw huidige meetproces',
              'FINISHED': 'Dit is een voltooid meetproces',
              'RESULTS': {
                'CURRENT': 'Het meetproces is niet voltooid',
                'FINISHED': 'Afgerond meetproces'
              }
            },
            'MEDIR_M5':{
              'TITULO': 'WELKOM BIJ METEN OP AFMETINGEN',
              'CURRENT': 'Dit is uw huidige meetproces',
              'FINISHED': 'Dit is een voltooid meetproces',
              'RESULTS': {
                'CURRENT': 'Het meetproces is niet voltooid',
                'FINISHED': 'Afgerond meetproces'
              }
            },
            'MEDIR_M6':{
              'TITULO': 'WELKOM BIJ METING OM TE CERTIFICEREN',
              'CURRENT': 'Dit is uw huidige meetproces',
              'FINISHED': 'Dit is een voltooid meetproces',
              'RESULTS': {
                'CURRENT': 'Het meetproces is niet voltooid',
                'FINISHED': 'Afgerond meetproces'
              }
            },
            'PULSE':{
              'TITULO': 'WELKOM BIJ PULSE CHECK',
              'ADMINTITULO': 'BEHEERDER PULSCONTROLES',
              'PRODU': 'Pulscontrole',
              'CURRENT': 'Dit is uw huidige Pulse Check-proces',
              'PULSOS': 'Dit is een Pulse Check-proces',
              'FINISHED': 'Dit is een voltooid Pulse Check-proces',
              'ENTRAR': 'Begin',
              'CARGANDO_PULSE':'Pulscontroles aan het laden in uitvoering',
              'RESULTS': {
                'CURRENT': 'Pulscontroleproces niet voltooid',
                // 'FINISHED': 'Finished Pulse Check process'
                'FINISHED': 'Dit is uw huidige Pulse Check-proces'
              }
            },
            'FOCUS':{
              'SECTION': 'Groepsbeheerder',
              'TITLE': 'Groepsbeheerder',
              'SUBTI': 'Selectie of creatie van groepen',
              'LAND': {
                'NAME': 'Enquête naam',
                'INICIO': 'Startdatum',
                'FIN': 'Streefdatum',
                'AVANCE': 'Vooruitgaan',
                'ESTADO': 'Toestand',
                'COMP': 'Gedrag',
                'CREARENC': 'Maak een enquête',
                'DELETE': 'Verwijderen',
                'EDIT': 'Bewerk',
              },
              'TITULO': 'WELKOM IN FOCUS AREA',
              'CURRENT': 'Dit is je huidige focusgebiedsproces ',
              'FINISHED': 'Dit is een voltooid focusgebiedsproces',
              'RESULTS': {
                'CURRENT': 'Focusgebied-proces niet voltooid',
                'FINISHED': 'Voltooid Focusgebied-proces'
              }
            },
            'FOCUS_1':{
              'SECTION': 'Groepsbeheerder',
              'TITLE': 'Groepsbeheerder',
              'SUBTI': 'Selectie of creatie van groepen',
              'ADMINTITULO': 'AANDACHTSGEBIEDEN VAN DE BEHEERDER',
              'PRODU': 'Aandachtsgebied',
              'CARGANDO_FOCUS':'Laden aandachtsgebied in uitvoering',
              'TAB_PROC_FOC':'Focusgebied Processen',
              'TAB_SUBIDA_COLB_FOC':'Collaborator upload',
              'INST_MOD_FILTER_1':'Upload uw lijst van medewerkers',
              'INST_MOD_FILTER_2':'Voer de enquête van uw keuze in',
              'LAND': {
                'NAME': 'Enquête naam',
                'INICIO': 'Startdatum',
                'FIN': 'Streefdatum',
                'AVANCE': 'Vooruitgaan',
                'ESTADO': 'Toestand',
                'COMP': 'Gedrag',
                'CREARENC': 'Maak een enquête',
                'DELETE': 'Verwijderen',
                'EDIT': 'Bewerk',
              },
              'TITULO': 'WELKOM IN FOCUS AREA',
              'CURRENT': 'Dit is je huidige focusgebiedsproces ',
              'FINISHED': 'Dit is een voltooid focusgebiedsproces',
              'RESULTS': {
                'CURRENT': 'Focusgebied-proces niet voltooid',
                'FINISHED': 'Voltooid Focusgebied-proces'
              }
            },
            'MEDIR_M9':{
              'TITULO': 'WELKOM BIJ INNMOTION ONDERZOEK',
              'CURRENT': 'Dit is je huidige focusgebiedsproces ',
              'FINISHED': 'Dit is een voltooid focusgebiedsproces',
              'RESULTS': {
                'CURRENT': 'Focusgebied-proces niet voltooid',
                'FINISHED': 'Voltooid Focusgebied-proces'
              }
            },
          },
          'DONE': 'Toepassingsjaar: ',
          'LEGA': 'Legacy results',
          'FOCUS': 'ONDERZOEKEN NAAR HET FOCUSGEBIED',
          'ENTRAR': 'Begin',
          'IR':'Gaan',
          ////instituto turquia///
          'INST-TURQUEY':{
            'TITULO':'Cultuurbrief ve Cultuuraudit 5.0',
            'TITULO-1':'Cultuurbrief ve Cultuuraudit 5.0',
            'TITULO1':'Cultuurbrief ve Cultuuraudit 5.0',
            'TITULO2':'Cultuurbrief 5.0',
            'TITULO3':'Cultuur Audit 5.0',
            'TITULO4':'Speciale Lijst',

          },
          'INST-CHINA':{
            'TITULO':'Cultuur Audit',
            'TITULO1':'Cultuur Audit',
            'TITULO2':'Cultuur Audit 5.0',
            'TITULO3':'Cultuur Audit SP',
          },
          'INST-ESP':{
            'TITULO':'Cultuur Audit',
            'TITULO1':'Cultuur Audit',
            'TITULO2':'Cultuur Audit 5.0',
            'TITULO3':'Action Plan',
          }
        },
        'STEPSTAT': {
          'LOCK': 'Stap op slot',
          'PEND': 'Stap open',
          'COMP': 'Stap voltooid '
        },
        'NOPRODUCTS': {
          'TITULO': 'Uw bedrijf heeft geen verworven producten',
          'SUBTI': 'Informatie over het aanbod'
        },
        'GUIA35': {
          'TITULO': 'Gids NOM-035-STPS-2018',
          'SUBTITULO':'Omschrijving',
          'DESCRIPCION': 'Informatie over NOM-035-STPS-2018',
          'ENTRAR': 'BEGIN'
         },
        'ENCUESTA35': {
          'TITULO': 'Onderzoeker NOM-035-STPS-2018',
          'TITULO2': 'Onderzoeker NOM-035-STPS-2018',
          'SUBTITULO':'Omschrijving',
          'DESCRIPCION': 'De volgende sectie is van een landmeter van NOM-035-STPS-2018, waarin de verschillende psychosociale risicofactoren in de organisatorische omgeving van werknemers zullen worden geïdentificeerd',
          'ENTRAR': 'BEGIN'
        },
        'CERTIFICAR_ESPAIN': {
          'TITULO': 'Diagnostiseren',
        },
        'Amco': {
          'TITULO': 'Amco',
        },
        'Trabajo_digno': {
            'TITULO': 'Fatsoenlijk werk',
          },
          'Primer_empleo': {
            'TITULO': 'Eerste baan',
          },
          'NOM35V3': {
              'TITULO': 'Norm 035 3.0'
          },
          'CERTIFICAR_C4': {
              'TITULO': 'Zilveren certificaat'
          },
        'CERTIFICAR': {
          'TITULO': 'Certificeren',
          'TITULO_ESPAIN': 'Diagnostiseren',
          'STEPS': {
            'STP1': {
              'WIZBT': 'Talen',
              'TITULO': 'Talen',
              'SUBTI': 'Talen selectie'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'NPS-editie'
            },
            'STP1-1': {
              'WIZBT': 'Verklaringen',
              'TITULO': 'Verklaringen',
              'SUBTI': 'Verklaringen bewerken'
            },
            'STP1-FOCUS-PLANTILLA': {
              'WIZBT': 'Sjablonen',
              'TITULO': 'Sjablonen',
              'SUBTI': 'Verklaringen bewerken'
            },
            'STP2': {
              'WIZBT': 'Voor alle praktijken',
              'TITULO': 'Voor alle praktijken',
              'SUBTI': 'Invoegen voor alle praktijken van uw bedrijf voor de enquête'
            },
            'STP_CONTROL': {
              'WIZBT': 'Controle vraag',
              'TITULO': 'Controle vraag',
              'SUBTI': 'De controlevraag bewerken'
            },
            'STP3': {
              'WIZBT': 'Demografie',
              'TITULO': 'Demografie',
              'SUBTI': 'Voer de demografische informatie in die in de enquête moet worden weergegeven. OPMERKING: Demografische gegevens in geel zijn optioneel'
            },
            'STP3-1': {
              'WIZBT': 'Open vragen',
              'TITULO': 'Open vragen',
              'SUBTI': 'Voeg de open vragen in'
            },
            'STP4': {
              'WIZBT': 'Aanvullingen',
              'TITULO': 'Aanvullingen',
              'SUBTI': 'Voeg aanvullende vragen in voor de enquête'
            },
            'STP4-FOCUS-PLANTILLA': {
              'WIZBT': 'Gepersonaliseerd',
              'TITULO': 'Gepersonaliseerd',
              'SUBTI': 'Voeg gepersonaliseerde vragen in voor de enquête '
            },
            'STP4-1': {
              'WIZBT': 'Genereer enquête',
              'TITULO': 'Genereer enquête',
              'SUBTI': 'Genereer enquête',
              'WIZBT2': 'Enquête',
              'TITULO2': 'Enquête',
            },
            'STP5': {
              'WIZBT': 'Participants',
              'TITULO': 'Participants',
              'SUBTI': 'Upload de werknemersdatabase van uw bedrijf'
            },
            'STP6': {
              'WIZBT': 'Plan een enquête',
              'TITULO': 'Plan een enquête',
              'SUBTI': 'Plan een enquête\' datums voor het starten en herinneren van herinneringen'
            },
            'STP7': {
              'WIZBT': 'Afzender van e-mail',
              'TITULO': 'Afzender van e-mail',
              'SUBTI': 'Stuur de enquête-uitnodiging naar uw pilotdeelnemers'
            },
            // 'STP8': {
            //   'WIZBT': 'Survey close',
            //   'TITULO': 'Survey close',
            //   'SUBTI': 'Progress before the closing of the survey'
            // },
            'STP8': {
              'WIZBT': 'Opvolging van het onderzoek',
              'TITULO': 'Opvolging van het onderzoek',
              'SUBTI': 'Vorderingen vóór de sluiting van de enquête'
            },
            'STP9': {
              'WIZBT': 'Activeer enquête',
              'TITULO': 'Activeer enquête',
              'SUBTI': 'Activeer de enquête'
            },
            'STP10': {
              'WIZBT': 'Sjabloon',
              'TITULO': 'Wijzigingen aanbrengen in de sjabloon',
              'SUBTI': 'Sjabloon'
            },
            'STP_VOICE': {
              'WIZBT': 'Spraakinstellingen',
              'TITULO': 'Stel de spraakinstellingen in voor de enquête met audio',
              'SUBTI': 'Stel de spraakinstellingen in voor de enquête met audio'
            }
          }
        },
        'CERTIFICARAMCO': {
          'TITULO': 'AMCO',
        },
        'CERTIFICARTRABADIG': {
          'TITULO': 'Fatsoenlijk werk',
        },
        'CERTIFICARADICPRIEMPL': {
          'TITULO': 'Eerste baan',
        },
        'CERTIFICAR_C2': {
          'TITULO': 'Izzi',
        },
        'CERTIFICAR35': {
          'TITULO': 'NOM-035-STPS-2018',
          'LANDING': {
            'TITULO': 'WELCOME TO NOM-035-STPS-2018',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Languages selection'
            },
            'STP2': {
              'WIZBT': 'Voor alle praktijken',
              'TITULO': 'Voor alle praktijken',
              'SUBTI': 'Insert the For All practices of your company for the survey'
            },
            'STP3': {
              'WIZBT': 'Demografie',
              'TITULO': 'Demografie',
              'SUBTI': 'Insert the demographics information to be shown in the survey'
            },
            'STP4': {
              'WIZBT': 'Aanvullingen',
              'TITULO': 'Aanvullingen',
              'SUBTI': 'Voeg aanvullende vragen in voor de enquête'
            },
            'STP5': {
              'WIZBT': 'Deelnemers',
              'TITULO': 'Deelnemers',
              'SUBTI': 'U heeft uw deelnemersdatabase niet geladen'
            },
            'STP6': {
              'WIZBT': 'Plan een enquête',
              'TITULO': 'Plan een enquête',
              'SUBTI': 'Plan de startdatum en de herinneringsdata van de enquête'
            },
            'STP7': {
              'WIZBT': 'Afzender van e-mail',
              'TITULO': 'Afzender van e-mail',
              'SUBTI': 'Stuur de enquête-uitnodiging naar uw medewerker'
            },
            'STP8': {
              'WIZBT': 'Onderzoek dichtbij',
              'TITULO': 'Onderzoek dichtbij',
              'SUBTI': 'Voortgang vóór afsluiting van de enquête'
            },'STP9':{
              'WIZBT': 'Communicatie plan',
              'TITULO': 'Communicatie plan',
              'SUBTI': 'Stuur de enquête-uitnodiging naar uw medewerker'
            },'STP10':{
              'WIZBT': 'Deelnemers',
              'TITULO': 'Deelnemers',
              'SUBTI': 'Maak u klaar voor de NOM-035-STPS-2018-enquête '
            }
          }
        },
        'PULSE': {
          'TITULO': 'Pulscontrole',
          'LANDING': {
            'TITULO': 'WELKOM BIJ PULSE CHECK',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          },
          'STEPS': {
            // 'STP1': {
            //   'WIZBT': 'Languages',
            //   'TITULO': 'Languages',
            //   'SUBTI': 'Languages selection',
            // },
            // 'STP1-1': {
            //   'WIZBT': 'Statements',
            //   'TITULO': 'Statements',
            //   'SUBTI': 'Statements selection'
            // },
            // 'STP2': {
            //   'WIZBT': 'For All practices',
            //   'TITULO': 'For All practices',
            //   'SUBTI': 'Insert the For All practices of your company for the survey'
            // },
            // 'STP3': {
            //   'WIZBT': 'Demographics',
            //   'TITULO': 'Demographics',
            //   'SUBTI': 'Insert the demographics information to be shown in the survey'
            // },
            // 'STP3-1': {
            //   'WIZBT': 'Open questions',
            //   'TITULO': 'Open questions',
            //   'SUBTI': 'Insert the open questions'
            // },
            // 'STP4': {
            //   'WIZBT': 'Additionals',
            //   'TITULO': 'Additionals',
            //   'SUBTI': 'Insert additional questions for the survey'
            // },
            // 'STP5': {
            //   'WIZBT': 'Participants',
            //   'TITULO': 'Participants',
            //   'SUBTI': 'Upload your company collaborators database'
            // },
            'STP6': {
              'WIZBT': 'Plan een enquête',
              'TITULO': 'Plan een enquête',
              'SUBTI': 'Plan onderzoeksdata Pulse Check'
            },
            'STP7': {
              'WIZBT': 'Afzender van e-mail',
              'TITULO': 'Afzender van e-mail',
              'SUBTI': 'Stuur de enquête-uitnodiging naar uw medewerkers'
            },
            'STP8': {
              'WIZBT': 'Onderzoeksvoortgang',
              'TITULO': 'Onderzoeksvoortgang',
              'SUBTI': 'Controleer de voortgang van de onderzoeken Pulse Check',
            }
          }
        },
        'CERTIFICAR_C1': {
          'TITULO': 'Alternatief certificeren ',
          'LANDING': {
            'TITULO': 'WELKOM BIJ ALTERNATIEVE CERTIFICATIE',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR': {
          'TITULO': 'Meting',
          'LANDING': {
            'TITULO': 'WELKOM BIJ METING',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR_M1': {
          'TITULO': 'Meting verbeterd',
          'LANDING': {
            'TITULO': 'WELKOM BIJ METING VERBETERD',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR_M2': {
          'TITULO': 'Meting + MST',
          'LANDING': {
            'TITULO': 'WELKOM BIJ MEASUREMENT + MST ',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR_M3': {
          'TITULO': 'Meting per oppervlakte',
          'LANDING': {
            'TITULO': 'WELKOM BIJ METING OP GEBIEDEN ',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR_M4': {
          'TITULO': 'Meting door leiders',
          'LANDING': {
            'TITULO': 'WELKOM BIJ METING DOOR LEIDERS',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR_M5': {
          'TITULO': 'Meting op maat',
          'LANDING': {
            'TITULO': 'WELKOM BIJ METEN OP AFMETINGEN',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR_M6': {
          'TITULO': 'Meting om te certificeren',
          'LANDING': {
            'TITULO': 'WELKOM BIJ METING OM TE CERTIFICEREN',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'MEDIR_M9': {
          'TITULO': 'Innmotion enquête',
          'LANDING': {
            'TITULO': 'WELKOM BIJ INNMOTION ONDERZOEK',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          }
        },
        'FOCUS':{
          'TITULO': 'Focusgebied',
          'LANDING': {
            'TITULO': 'WELKOM IN FOCUS AREA',
            'DONE': 'Toepassingsjaar: ',
            'ENTRAR': 'Begin'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Talen',
              'TITULO': 'Talen',
              'SUBTI': 'Talen selectie'
            },
            'STP2': {
              'WIZBT': 'Beheer groepen',
              'TITULO': 'Beheer groepen',
              'SUBTI': 'Voeg de For All-praktijken van uw bedrijf in voor de enquête '
            },
            'STP3': {
              'WIZBT': 'Enquêtes beheren',
              'TITULO': 'Enquêtes beheren',
              'SUBTI': 'Voer de demografische informatie in die in de enquête moet worden weergegeven'
            },
            'STP4': {
              'WIZBT': 'Onderzoeksbord',
              'TITULO': 'Onderzoeksbord',
              'SUBTI': 'Voeg aanvullende vragen in voor de enquête'
            }
          }
        },
        'LEADER_GO':{
          'TITULO_ADMIN': 'LEADER GO® WELKOM BEHEERDER',
          'TITULO': 'LEADER GO® WELKOM',
          'TITULO_PRODUCT':'Leader Go® beheerder',
          'TITULO_PRODUCT2':'Leader Go®',
          'LANDING': {
            'TITULO': 'WELKOM BIJ LEADER GO',
            'DONE': 'Jaar van toepassing: ',
            'ENTRAR': 'Start'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Talen',
              'TITULO': 'Talen',
              'SUBTI': 'Taal Selectie'
            },
            'STP2': {
              'WIZBT': 'selectie van de leider',
              'TITULO': 'Selectie leiders',
              'SUBTI': 'Selectie leiders',
            },
            'STP3': {
              'WIZBT': 'Communicatieberichten',
              'TITULO': 'Communicatieberichten',
              'SUBTI': 'Aanmelden om de mails te bewerken',
            },
            'STP4': {
              'WIZBT': 'Bevestiging',
              'TITULO': 'Bevestiging',
              'SUBTI': 'Invoeren om verzending van e-mails te bevestigen',
            },
            'STP5': {
              'WIZBT': 'Voorschot',
              'TITULO': 'Voorschot',
              'SUBTI': 'Voorschot'
            }
          }

        },
        'ACTION_GO':{
          'TITULO_ADMIN': 'ACTION GO® WELCOME ADMINISTRATOR',
          'TITULO': 'ACTION GO® WELCOME',
          'TITULO_PRODUCT':'Action GO® beheerder',
          'TITULO_PRODUCT2':'Action GO®',
        },
        'LANDING_REQUERIMIENTOSV3':{
            'TITULO':'Technische benodigdheden',
            'EXTERNAL_PORTAL': 'Kopieer de externe RT-URL',
            'COPYA_MESSAGE':'De url is naar het klembord gekopieerd ',

        },
        'GOFLOW':{
          'TITULO': 'GoFlow Resultaten',
        },
      }
    }
};
